module.exports = __webpack_public_path__ + "assets/img/mecha-btn-333d1ffd.png";